// Leitura TOLERANTE do branding do parceiro pro BrandProvider.
//
// Por que existe: o objeto de branding persistido em `iptv:session.branding`
// pode estar no shape LEGADO `{ color: '#7C3AED' }` (sem `primaryColor`) —
// é o que o dump de aparelhos reais mostra (ex.: HXTV em prod, ver
// session-rehydrate.test.tsx). A reidratação do zustand `persist` lê esse
// objeto CRU (não passa pelo Zod de novo), então `branding.primaryColor` vem
// `undefined` e a cor do parceiro nunca chega ao shim de marca — cai no roxo
// default do app. Esta função tolera o alias legado `color` na LEITURA. O
// canônico continua sendo `primaryColor`.
//
// Função PURA (sem DOM/store) — testável direto. Ver branding-read.test.ts.

import type { ProviderBranding } from '@app-iptv/shared'

export interface BrandColors {
  primaryColor: string | null
  secondaryColor: string | null
}

/**
 * Resolve as cores de marca pro BrandProvider a partir do branding persistido,
 * tolerando o alias legado `color` (primária). `secondaryColor` não tem alias
 * legado conhecido. `null` em qualquer uma sinaliza "sem override" (o
 * BrandProvider volta ao fallback `var(--app-*)` — pré-provider / direct /
 * logout).
 */
export function resolveBrandColors(
  branding: ProviderBranding | null | undefined,
): BrandColors {
  return {
    primaryColor: branding?.primaryColor ?? branding?.color ?? null,
    secondaryColor: branding?.secondaryColor ?? null,
  }
}
